import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import _jsx from '@babel/runtime/helpers/jsx';
import { getDisplayName, hyphenatedbem } from '@vpp-frontend-components/common';
const _excluded$1 = ["children", "size", "className"];
const DEFAULT_COL_SIZE = 1;
const MAX_COL_SIZE = 5;
const namespace$3 = 'ui-pdp-container';

/**
 * Col component
 * @typedef {import('../../../index').Col}
 */
const Col = _ref => {
  let {
      children = null,
      size = DEFAULT_COL_SIZE,
      className = ''
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  if (typeof size !== 'number') {
    console.error(`Invalid prop "size" supplied to Col, "number" is expected "${typeof size}" provided, validation failed.`);
  }
  if (size > MAX_COL_SIZE) {
    console.error(`Invalid prop "size" supplied to Col, number lower than ${MAX_COL_SIZE} expected, validation failed.`);
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(`${namespace$3}__col col-${size}`, className)
  }, rest), children);
};
const namespace$2 = 'ui-pdp-container';

/**
 * Row component
 * @typedef {import('../../../index').Row}
 */
const RowFordwardRef = (_ref, ref) => {
  let {
    id = null,
    children,
    modifier = null,
    className = ''
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(`${namespace$2}__row`, className, {
      [`${namespace$2}__row--${modifier}`]: modifier
    }),
    ref: ref,
    id: id
  }, children);
};
const Row = /*#__PURE__*/forwardRef(RowFordwardRef);
const _excluded = ["featureName"];

/**
 * withRow HOC
 * @typedef {import('../../../index').withRow}
 */
const withRow = (modifier, className) => WrappedComponent => {
  const WithRow = _ref => {
    let {
        featureName = null
      } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/_jsx(Row, {
      id: modifier,
      modifier: hyphenatedbem(modifier) || hyphenatedbem(featureName),
      className: className
    }, void 0, /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      featureName: featureName
    })));
  };
  WithRow.displayName = `withRow(${getDisplayName(WrappedComponent)})`;
  return WithRow;
};
const namespace$1 = 'ui-pdp-container';

/**
 * Container component
 * @typedef {import('../../../index').Container}
 */
const Container = _ref => {
  let {
    children,
    className = ''
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: classNames(namespace$1, className)
  }, void 0, children);
};
const namespace = 'ui-pdp-container__separator';

/**
 * Separator component
 * @typedef {import('../../../index').Separator}
 */
const Separator = _ref => {
  let {
    className = ''
  } = _ref;
  return /*#__PURE__*/_jsx("hr", {
    className: classNames(namespace, className)
  });
};
const separatorType = {
  LINE: 'LINE',
  SPACE: 'SPACE'
};
const emptySeparatorToProps = _ref => {
  let {
    separator_type: type,
    background_color: bgColor,
    height
  } = _ref;
  const namespace = type === separatorType.LINE ? 'ui-vpp-with--separator' : 'ui-vpp-with--empty--separator';
  const classes = [bgColor, height].reduce((acum, current) => current ? `${acum} ${namespace}--${current}` : `${acum}`, '');
  return {
    className: `${namespace} ${classes}`
  };
};
export { Col, Container, Row, Separator, emptySeparatorToProps, withRow };
